import { buildModule } from '../utils';

import detail from './detail';
import list from './list';

export default buildModule()
	.withSubmodules({
		detail,
		list,
	});

